// @ts-nocheck
/* eslint-disable */

import React from 'react';
import AddEntity from 'app/components/CRUD/AddEntity';

import {
  CONFIG_PATHS,
  CONFIG_ROUTES,
} from 'app/configuration/configuration-api';

/**
 * maxLength on each field mirrors public.fare_media_issuers exactly, so the
 * input stops the user before the API has to reject the request:
 *   en_issuer_name / ar_issuer_name  varchar(45)  NOT NULL
 *   phone / email                    varchar(45)  NULL
 *   address                          varchar(255) NULL
 * The API validates the same limits — this is convenience, not the boundary.
 */
const inputs = [
  {
    name: 'en_issuer_name',
    labelKey: 'NameEnglish',
    type: 'text',
    required: true,
    maxLength: 45,
    defaultValue: '',
  },
  {
    name: 'ar_issuer_name',
    labelKey: 'NameArabic',
    type: 'text',
    required: true,
    maxLength: 45,
    defaultValue: '',
  },
  {
    name: 'phone',
    labelKey: 'Phone',
    type: 'text',
    required: false,
    maxLength: 45,
    defaultValue: '',
  },
  {
    name: 'email',
    labelKey: 'Email',
    type: 'text',
    required: false,
    maxLength: 45,
    defaultValue: '',
  },
  {
    name: 'address',
    labelKey: 'Address',
    type: 'text',
    required: false,
    maxLength: 255,
    defaultValue: '',
  },
];

const AddFareMediaIssuer: React.FC = () => {
  const buildSubmitPayload = formValues => {
    const payload: any = {
      en_issuer_name: formValues.en_issuer_name,
      ar_issuer_name: formValues.ar_issuer_name,
    };

    // Only send the optional columns when they were actually filled in — the
    // API treats an absent key as "leave it NULL".
    ['phone', 'email', 'address'].forEach(key => {
      const value = (formValues[key] || '').trim();
      if (value) payload[key] = value;
    });

    return payload;
  };

  return (
    <AddEntity
      pageTitle="AddNewFareMediaIssuer"
      backUrl={CONFIG_ROUTES.fareMediaIssuers}
      submitApiUrl={CONFIG_PATHS.fareMediaIssuers}
      inputs={inputs}
      dropdowns={[]}
      buildSubmitPayload={buildSubmitPayload}
      successMessage="FareMediaIssuerCreatedSuccessfully"
      addButtonLabel="Add"
      subsystemName="FareMediaIssuers"
      permissionSystem="masterConfig"
    />
  );
};

export default AddFareMediaIssuer;
